<template>
    <div v-if="isDraw && model.balance > 0 || !isDraw">
      <b-row class="m-2 category-header">
        <b-col md="6">
          <div :class="{'pt-2': isEditing}">
            <span
              class="pointer-cursor"
              @click="collapseHandler"
              :title="buttonTitle"
              v-b-tooltip.hover
              v-b-tooltip.righttop
            >
              <font-awesome-icon :icon="icon" :class="iconClass" />
              <span class="my-auto ml-2 mr-2 h5">{{ title }}</span>
            </span>
          </div>
        </b-col>
        <b-col md="6">
          <balance v-if="isDraw" :balance="model.balance" :total="totalFunction">
          </balance>
          <editable-total
            v-else
            :total="totalFunction"
            @total-changed="totalChanged"
            @edit-total="onEditTotal"
          />
        </b-col>
      </b-row>
      <b-collapse :id="name" v-model="collapse" class="mt-2">
        <b-row>
          <b-col>
            <vue-form-generator
              :schema="schema"
              :options="options"
              :model="model"
              :ref="name"
            ></vue-form-generator>
          </b-col>
        </b-row>
      </b-collapse>
  </div>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import EditableTotal from '@/components/my_deals/actions/estimate_of_repairs/EditableTotal';
import Balance from '@/components/my_deals/actions/estimate_of_repairs/Balance';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons';


library.add([faAngleRight, faAngleDown]);


export default {
  components: {
    'vue-form-genertor': VueFormGenerator.component,
    EditableTotal,
    Balance,
  },
  props: [
    'schema', 'options', 'model', 'name', 'totalFunction', 'total', 'title', 'isDraw',
  ],
  data() {
    return {
      collapse: false,
      isEditing: false,
    };
  },
  computed: {
    icon() {
      return this.collapse ? 'angle-down' : 'angle-right';
    },
    iconClass() {
      return this.disableClick ? 'text-muted' : 'text-anchor';
    },
    buttonTitle() {
      return this.disableClick ?
        'Reset the value on the right to be able to edit the internal fields again.' :
        '';
    },
    disableClick() {
      return this.model.total && this.model.total > 0;
    },
  },
  methods: {
    totalChanged(total) {
      const innerTotal = total || 0.00;
      if (innerTotal > 0.00) {
        this.collapse = false;
      }

      this.isEditing = false;
      this.$emit('total-changed', innerTotal);
    },
    onEditTotal() {
      this.isEditing = true;
    },
    collapseHandler() {
      if (!this.disableClick) {
        this.collapse = !this.collapse;
      }
    },
    reset() {
      this.collapse = false;
    },
    validate() {
      if (this.isDraw && this.totalFunction > this.model.balance) {
        return false;
      }
      if (this.$refs[this.name]) {
        return this.$refs[this.name].validate();
      }
      return true;
    },
  },
};
</script>

<style scoped>
  .category-header {
    border-bottom: 1px solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/my_deals/actions/estimate_of_repairs/EstimateOfRepairsCategory.vue